/**
 * Roll up human-agent QA stats from reporting leaderboard rows.
 */

export class HumanAgentQaSummaryDeriver {
  /**
   * @param {Array<Record<string, unknown>>} leaderboard
   */
  buildSummary(leaderboard) {
    const rows = Array.isArray(leaderboard) ? leaderboard : [];
    let totalAnalyzedSessions = 0;
    let weightedOverall = 0;
    let weight = 0;

    for (const agent of rows) {
      const qa = agent?.qa_analysis;
      if (!qa || typeof qa !== "object") continue;
      const n = Number(qa.total_qa_analyses) || 0;
      if (n <= 0) continue;
      totalAnalyzedSessions += n;
      const avg = Number(qa.avg_overall_score) || 0;
      weightedOverall += avg * n;
      weight += n;
    }

    return {
      totalAnalyzedSessions,
      avgOverallScore: weight > 0 ? Math.round((weightedOverall / weight) * 10) / 10 : 0,
      agentCountWithQa: rows.filter(
        (a) => Number(a?.qa_analysis?.total_qa_analyses) > 0,
      ).length,
    };
  }

  /**
   * @param {Array<Record<string, unknown>>} leaderboard
   */
  buildAgentRows(leaderboard) {
    const rows = Array.isArray(leaderboard) ? leaderboard : [];
    return rows
      .map((agent) => {
        const qa = agent?.qa_analysis && typeof agent.qa_analysis === "object" ? agent.qa_analysis : {};
        const total = Number(qa.total_qa_analyses) || 0;
        return {
          id: agent.id,
          name: String(agent.name ?? "Agent"),
          totalQaAnalyses: total,
          avgOverallScore: Number(qa.avg_overall_score) || 0,
          avgEmpathy: Number(qa.avg_empathy_tone_score) || 0,
          avgGrammar: Number(qa.avg_grammar_spelling_score) || 0,
        };
      })
      .filter((r) => r.totalQaAnalyses > 0)
      .sort((a, b) => b.avgOverallScore - a.avgOverallScore);
  }

  /**
   * @param {Array<Record<string, unknown>>} leaderboard
   */
  build(leaderboard) {
    const summary = this.buildSummary(leaderboard);
    const agentRows = this.buildAgentRows(leaderboard);
    return {
      ...summary,
      agentRows,
      isEmpty: summary.totalAnalyzedSessions === 0,
    };
  }
}

export const humanAgentQaSummaryDeriver = new HumanAgentQaSummaryDeriver();
